import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "noCountryDataText" }, " No data available ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_information_select_menu = _resolveComponent("information-select-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_risk_information = _resolveComponent("risk-information")!
  const _component_key_figures = _resolveComponent("key-figures")!
  const _component_esg_view = _resolveComponent("esg-view")!
  const _component_movement_focus = _resolveComponent("movement-focus")!
  const _component_industry_performance = _resolveComponent("industry-performance")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_information_select_footer = _resolveComponent("information-select-footer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: _normalizeClass(["mainInfoHolder", _ctx.getModalClasses()]),
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
    persistent: "",
    value: "true",
    "min-height": _ctx.isMobile ? _ctx.minHeight : '',
    "min-width": _ctx.isMobile ? '100vw' : '90%',
    scrim: !_ctx.isMobile,
    fullscreen: _ctx.isMobile
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "mainInfoCard" }, {
        default: _withCtx(() => [
          (!_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_v_card_title, {
                key: 0,
                class: "d-flex justify-space-between align-center informationSelectMenu pa-0 pl-6 pr-6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_information_select_menu, {
                    activeTab: _ctx.activeTab,
                    "onUpdate:activeTab": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
                    tabs: _ctx.tabs,
                    class: "informationSelectMenu"
                  }, null, 8, ["activeTab", "tabs"]),
                  _createVNode(_component_v_btn, {
                    icon: "",
                    onClick: _ctx.closeModal,
                    ripple: false,
                    variant: "flat",
                    class: "crossButton iconButton_light"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-close")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { class: "mainInfoCardText" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "12" }, {
                    default: _withCtx(() => [
                      (_ctx.menuMode == 'risk' || _ctx.menuMode == null)
                        ? (_openBlock(), _createBlock(_component_risk_information, { key: 0 }))
                        : _createCommentVNode("", true),
                      (_ctx.menuMode == 'keyFigures')
                        ? (_openBlock(), _createBlock(_component_key_figures, { key: 1 }))
                        : _createCommentVNode("", true),
                      (_ctx.menuMode == 'esg')
                        ? (_openBlock(), _createBlock(_component_esg_view, { key: 2 }))
                        : _createCommentVNode("", true),
                      (_ctx.focusMode == 'movement')
                        ? (_openBlock(), _createBlock(_component_movement_focus, { key: 3 }))
                        : _createCommentVNode("", true),
                      (_ctx.menuMode == 'industry')
                        ? (_openBlock(), _createBlock(_component_industry_performance, { key: 4 }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.noCountryData)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    class: "noCountryDataHolder"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          (_ctx.isMobile)
                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "10" }),
                                  _createVNode(_component_v_col, { cols: "1" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        icon: "",
                                        onClick: _ctx.closeModal,
                                        ripple: false,
                                        variant: "flat",
                                        class: "crossButton iconButton_light"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode("mdi-close")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "1" })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _hoisted_1
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_ctx.focusMode)
        ? (_openBlock(), _createBlock(_component_information_select_footer, {
            key: 0,
            class: "informationSelectFooter"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "min-height", "min-width", "scrim", "fullscreen", "class"]))
}